import { render, staticRenderFns } from "./dep-adjust.vue?vue&type=template&id=fce5d2da&"
import script from "./dep-adjust.vue?vue&type=script&lang=js&"
export * from "./dep-adjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports